import { Image, Weight } from 'components'
import { StyledTransactionListHeader } from 'components/account-center/styled'
import { TextSize } from 'components/typography'
import styled from 'styled-components'
import { css } from 'styled-components'
import { GLOBAL_COLORS } from 'theme'
import { HeadWrapper } from '../../styled'
import { TransactionStatus } from 'sdk/omni/omni-transaction-service/types'

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 36px;
  align-items: center;
  justify-content: space-between;
  padding: 10px 18px 10px 18px;
  ${({ theme }) => theme.mediaWidth.Mobile`
  padding: 10px 12px 10px 15px;
`}
  ${({ theme }) => theme.mediaWidth.Tablet`
  padding: 10px 12px 10px 15px;
`}
  margin-right: 14.5px;
  cursor: pointer;
  transition: 0.4s all;
  &:hover {
    opacity: 0.7;
  }
`

export const PendingItemWrapper = styled(ItemWrapper)<{ failed: boolean }>`
  ${({ failed, theme }) =>
    failed &&
    css`
      background-color: ${theme.highlightAccent};
      border-radius: 270px;
      margin-bottom: 4px;
      :last-of-type {
        margin-bottom: 0px;
      }
    `}
`

export const AssetIconWrapper = styled(Image)`
  background-size: cover;
  height: 24px;
  width: 24px;
  border-radius: 50%;
`
export const StyledTXText = styled.span`
  font-size: ${TextSize.four};
  ${({ theme }) => theme.mediaWidth.Mobile`
  font-size: ${TextSize.small};
  `}

  color: ${({ theme }) => theme.primaryFontColor};
  font-weight: ${Weight.Medium};
`

export const StyledListWrapper = styled.div``

export const TextAndSubText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`

export const StyledTXSubText = styled.span`
  font-size: ${TextSize.small};
  color: ${({ theme }) => theme.secondaryFontColor};
  font-weight: ${Weight.Medium};
  ${({ theme }) => theme.mediaWidth.Mobile`
     font-size: ${TextSize.tiny};
  `}
`

export const StyledLeftColumn = styled.div`
  display: flex;
  flex-direction: row;
  gap: 7px;
  align-items: center;
`

export const StyledChainStatuses = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  ${({ theme }) => theme.mediaWidth.Mobile`
      gap: 2px;
  `}
`

export const ChainStatusWrapper = styled.div<{
  status: string
}>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid;
  background-color: ${({ theme }) => theme.bg};
  ${({ theme }) => theme.mediaWidth.Mobile`
    width: 18px;
    height: 18px;    
  `}

  border-color: ${({ status }) => {
    switch (status) {
      case TransactionStatus.INFLIGHT:
        return GLOBAL_COLORS.amberYellow
      case TransactionStatus.DELIVERED:
        return GLOBAL_COLORS.canopyGreen
      case TransactionStatus.FAILED:
        return GLOBAL_COLORS.volcanoRed
    }
  }};
`

export const ChainImageWrapper = styled.div`
  width: 18px;
  height: 18px;
  ${({ theme }) => theme.mediaWidth.Mobile`
  width: 14px;
  height: 14px;
  position: relative;
  `}
  & > svg {
    ${({ theme }) => theme.mediaWidth.Mobile`
    height: 14px;
    width: 14px;
    position: absolute;
    `}
    height: 18px;
    width: 18px;
  }
`

/**
 * Styled component for transaction failed text
 */
export const StyledTXFailedText = styled(StyledTXSubText)`
  color: ${GLOBAL_COLORS.volcanoRed};
  font-weight: ${Weight.Medium};
  font-size: ${TextSize.small};
  ${({ theme }) => theme.mediaWidth.Mobile`
     font-size: ${TextSize.tiny};
  `}
`

export const StyledTXFailedLink = styled(StyledTXSubText)`
  color: ${({ theme }) => theme.retryLinkColor};
  cursor: pointer;
  text-decoration: none;
  border-bottom: 1px solid;
  & > svg {
    & path {
      stroke: ${({ theme }) => theme.retryLinkColor};
    }
  }
`

/**
 * Wrapper for header part of list
 */
export const TransactionListHeaderWrapper = styled(HeadWrapper)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledClearText = styled(StyledTransactionListHeader)`
  text-decoration: underline;
  cursor: pointer;
`

export const StyledRightColumn = styled.div`
  font-size: ${TextSize.small};
  color: ${({ theme }) => theme.secondaryFontColor};
  font-weight: ${Weight.Medium};
  cursor: pointer;
`
